import React, { Component } from "react";
import { connect } from "react-redux";
import { CardBody } from "reactstrap";

import * as actions from "../../../redux/tasks/actions";
import { isFetchingTasks, getTasks, getSubTasks } from "../../../redux/tasks";
import { getActiveProject } from "../../../redux/projects";
import { getActiveTab } from "../../../redux/app";
import { isLoggedIn } from "../../../redux/user";

import type Project from "../../models/Project";
import type TaskCollection from "../../models/TaskCollection";
import type Task from "../../models/Task";
import type SubTaskCollection from "../../models/SubTaskCollection";
import type SubTask from "../../models/SubTask";
import TaskModal from "../components/modals/task-modal/TaskModal";
import TaskDeleteModal from "../components/modals/task-delete-modal/TaskDeleteModal";
import SubTaskDeleteModal from "../components/modals/subtask-delete-modal/SubTaskDeleteModal";
import TaskView from "./task-view/TaskView";
import GradientButton from "../../../components/input/GradientButton.jsx";
import { accountExpired } from "../../../helpers/Utils";

type OwnProps = {};

type StateProps = {
  isLoggedIn: boolean,
  tasks: TaskCollection,
  subTasks: SubTaskCollection,
  isFetchingTasks: boolean,
  project: ?Project,
  activeTab: TabKey,
};

type State = {
  showAddCategoryModal: boolean,
  showDeleteTaskModal: boolean,
  selectedTask: Task,
  showDeleteSubTaskModal: boolean,
  selectedSubTask: SubTask,
};

class TaskListView extends Component {
  props: Props;
  state: State = {
    showAddCategoryModal: false,
    showDeleteTaskModal: false,
    selectedTask: null,
    showDeleteSubTaskModal: false,
    selectedSubTask: null,
  };
  loadTasksPromise: ?Promise<void>;
  createTaskPromise: ?Promise<void>;

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.isLoggedIn && this.props.project) {
      this.loadTasksPromise = Promise.resolve(
        this.props.loadTasks(this.props.project.id)
      );
    }
  }

  handleLoggedOutUser() {
    this.loadDefaultTimelineEventsPromise &&
      this.loadDefaultTimelineEventsPromsie.cancel();
  }

  loadSubTasks(task: Task) {
    this.props.loadSubTasks(task.id);
  }

  openAddCategoryModal = () => {
    this.setState({
      showAddCategoryModal: true,
    });
  };

  closeAddCategoryModal = () => {
    this.setState({
      showAddCategoryModal: false,
    });
  };

  openDeleteTaskModal = (task: Task) => {
    this.setState({
      showDeleteTaskModal: true,
      selectedTask: task,
    });
  };

  closeDeleteTaskModal = () => {
    this.setState({
      showDeleteTaskModal: false,
      selectedTask: null,
    });
  };

  openDeleteSubTaskModal = (subtask: SubTask) => {
    this.setState({
      showDeleteSubTaskModal: true,
      selectedSubTask: subtask,
    });
  };

  closeDeleteSubTaskModal = () => {
    this.setState({
      showDeleteSubTaskModal: false,
      selectedSubTask: null,
    });
  };

  render() {
    return (
      <div className="tasklist-container">
        {this.props.isFetchingTasks ? "" : this.renderTable()}
        {this.state.showAddCategoryModal ? this.renderAddCategoryModal() : ""}
      </div>
    );
  }

  renderTable() {
    const project = this.props.project;
    const userHasOwnerPrivileges =
      this.props.project && this.props.project.role === "owner";

    return (
      <div>
        <div className="tasklist-title-container">
          <div className="project-title-container">
            <h1 className="project-title">{project.name}</h1>
          </div>
          {userHasOwnerPrivileges && !accountExpired(this.props.user)
            ? this.renderAddButton()
            : null}
        </div>
        {this.props.renderProjectNav()}
        <div className="tasks-list">{this.renderTasks()}</div>
        {this.state.showDeleteTaskModal ? this.renderDeleteTaskModal() : ""}
        {this.state.showDeleteSubTaskModal
          ? this.renderDeleteSubTaskModal()
          : ""}
      </div>
    );
  }

  renderAddButton() {
    return (
      <GradientButton
        title="+ Add Category"
        handleClick={this.openAddCategoryModal}
      />
    );
  }

  renderTasks() {
    const tasks = this.props.tasks.toArray();
    if (!this.props.tasks.length) {
      return <div className="no-tasks-notice">No tasks</div>;
    }
    return tasks.map(this.renderTaskRow);
  }

  renderTaskRow = (task: Task) => {
    const userHasOwnerPrivileges =
      this.props.project && this.props.project.role === "owner";

    return (
      <TaskView
        key={task.id}
        task={task}
        subTasks={this.props.subTasks}
        loadSubTasks={this.props.loadSubTasks}
        isOwner={userHasOwnerPrivileges}
        accountExpired={accountExpired(this.props.user)}
        createSubTask={this.props.createSubTask}
        openDeleteTaskModal={(task) => this.openDeleteTaskModal(task)}
        openDeleteSubTaskModal={(subTask) =>
          this.openDeleteSubTaskModal(subTask)
        }
        onRequestToggleSubTaskCompleteness={(subTask) =>
          this.props.setSubTaskCompleteness(subTask, !subTask.isComplete)
        }
      ></TaskView>
    );
  };

  renderAddCategoryModal = () => {
    return (
      <TaskModal
        onModalClose={() => this.closeAddCategoryModal()}
        user={this.props.user}
        project={this.props.activeProject}
      />
    );
  };

  renderDeleteTaskModal = () => {
    return (
      <TaskDeleteModal
        onModalClose={() => this.closeDeleteTaskModal()}
        task={this.state.selectedTask}
      ></TaskDeleteModal>
    );
  };

  renderDeleteSubTaskModal = () => {
    return (
      <SubTaskDeleteModal
        onModalClose={() => this.closeDeleteSubTaskModal()}
        subtask={this.state.selectedSubTask}
      ></SubTaskDeleteModal>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    activeTab: getActiveTab(state),
    project: getActiveProject(state),
    isLoggedIn: isLoggedIn(state),
    tasks: getTasks(state),
    subTasks: getSubTasks(state),
    isFetchingTasks: isFetchingTasks(state),
  };
};

export default connect(mapStateToProps, actions)(TaskListView);



// WEBPACK FOOTER //
// ./src/views/user/tasklist/TaskListView.js